<template>
  <h1>Näytä kohteet</h1>
</template>

<script>
export default {};
</script>

<style></style>
